import { print, type DocumentNode } from "graphql";

function canonicalValue(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonicalValue);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([key, nested]) => [key, canonicalValue(nested)])
    );
  }
  return value;
}

// Keep the complete request identity. A 32-bit hash can alias different strips;
// AST source locations also differ between the server and browser compilers.
export function apolloPrefetchKey(
  query: DocumentNode,
  variables: unknown
): string {
  return JSON.stringify([print(query), canonicalValue(variables || {})]);
}
